import request from '@aned/request';

// 每日车线任务复盘分页查询
export async function selectPage(params) {
  return request('/api/dispatchTaskCost/selectPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'dispatch',
  });
}

// 每日车线任务复盘数据导出
export async function selectexportClockingInData(params) {
  return request('/api/dispatchTaskCost/selectexportClockingInData', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'dispatch',
  });
}
